import React from 'react'
import { Row, Col } from 'reactstrap'
import { ContainerLg } from '../../GlobalStylesNew'
import styled from 'styled-components'
import theme from '../../theme'
import { TextLink } from '../Links'
import { facebookF, instagram, youtube, twitter } from '../Svg/elements'

export const links = [
  {
    title: 'PGA of America',
    url: 'https://www.pga.org/'
  },
  {
    title: 'Golf’s American Development Model',
    url: "/Golf's_American_Development_Model.pdf"
  },
  {
    title: 'Coach Parents',
    url: '/coach-parents'
  },
  {
    title: 'Contact Us',
    url: '/contact'
  }
]
export const privacyLinks = [
  {
    title: 'Privacy Policy',
    url: 'https://www.pga.org/privacy-policy'
  },
  {
    title: 'California Privacy Notice',
    url: 'https://pga.coach/pga-of-america/california-privacy-notice/'
  },
  {
    title: 'Terms of Service',
    url: 'https://pga.coach/pga-of-america/terms-of-service'
  },
  {
    title: 'Do Not Sell or Share My Personal Information',
    url: 'https://pga.coach/pga-of-america/do-not-sell'
  }
]

export const socialLinks = [
  {
    title: 'Instagram',
    url: 'https://www.instagram.com/',
    icon: instagram
  },
  {
    title: 'Twitter',
    url: 'https://twitter.com/',
    icon: twitter
  },
  {
    title: 'Facebook',
    url: 'https://www.facebook.com/groups/2010744555639212/',
    icon: facebookF
  },
  {
    title: 'Youtube',
    url: 'https://www.youtube.com/',
    icon: youtube
  }
]

export const FooterWrapper = styled.footer`
  background-color: ${p => p.theme.colors.navy};
  padding: 50px 0;
  @media (min-width: 768px) {
    padding: 60px 0;
  }
`

export const SocialList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media (min-width: 768px) {
    justify-content: flex-start;
  }
`

export const SocialLink = styled.a`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  color: ${p => p.theme.colors.white};
  line-height: 25px;
  font-size: 11px;
  text-align: center;
  background-color: ${p => p.theme.colors.transparent};
  margin: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 1px;
  position: relative;
  border: 1px solid ${p => p.theme.colors.white};
  &:hover {
    background-color: ${p => p.theme.colors.white};
    color: ${p => p.theme.colors.gray};
  }
  @media (min-width: 768px) {
    margin: 0 20px 0 0;
  }
`

export const Copyright = styled.div`
  font-size: small;
  color: ${theme.colors.white};
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.3),
      rgba(255, 255, 255, 0.3)
    ),
    #00234b;
  font-weight: 700;
  font-size: 12px;
  line-height: 50px;
  letter-spacing: 0.05em;
`

export const FooterNav = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
  @media (min-width: 768px) {
    flex-direction: row;
  }
  @media (min-width: 1024px) {
    width: 100%;
    justify-content: flex-start;
    margin-top: 0px;
  }
`
export const FooterNavSecondary = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 20px;
  padding-bottom: 20px;
  @media (min-width: 768px) {
    flex-direction: row;
  }
  @media (min-width: 1024px) {
    width: 100%;
    justify-content: center;
  }
`

export const FooterLink = styled(TextLink)`
  a {
    font-weight: 700;
    font-size: 12px;
    line-height: 30px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    text-align: center;
    padding: 0;
  }
  & + & {
    margin-top: 8px;
    @media (min-width: 768px) {
      margin: 0 0 0 30px;
    }
  }
`
export const FooterLinkSecondary = styled(TextLink)`
  position: relative;
  a {
    font-weight: 400;
    font-size: 12px;
    line-height: 30px;
    letter-spacing: 0.05em;
    text-align: center;
    padding: 0;
  }
  & + & {
    margin-top: 8px;
    @media (min-width: 768px) {
      margin: 0 0 0 30px;
    }
  }
  @media (min-width: 768px) {
    &:not(:first-of-type):before {
      left: -15px;
      width: 1px;
      height: 100%;
      content: '';
      position: absolute;
      background: #fff;
    }
  }
`

export const FooterV2 = () => (
  <>
    <FooterWrapper>
      <ContainerLg>
        <Row>
          {/* <Col lg='3'>
            <SocialList>
              {socialLinks.map(({ url, title, icon }) => (
                <SocialLink href={url} key={title} aria-label={title} target='_blank'>
                  <Svg d={icon} />
                </SocialLink>
              ))}
            </SocialList>
          </Col> */}
          <Col lg="12">
            <FooterNav>
              {links.map(({ url, title, icon }) => (
                <FooterLink
                  url={url}
                  key={title}
                  color={theme.colors.white}
                  hoverColor={theme.colors.gray}
                  padding="0 15px"
                  aria-label={title}
                >
                  {title}
                </FooterLink>
              ))}
            </FooterNav>
          </Col>
        </Row>
      </ContainerLg>
    </FooterWrapper>
    <Copyright>
      <ContainerLg>
        <FooterNavSecondary>
          {privacyLinks.map(({ url, title, icon }) => (
            <FooterLinkSecondary
              url={url}
              key={title}
              color={theme.colors.white}
              hoverColor={theme.colors.gray}
              padding="0 15px"
              aria-label={title}
            >
              {title}
            </FooterLinkSecondary>
          ))}
        </FooterNavSecondary>
        © COPYRIGHT {new Date().getFullYear()}. All Rights Reserved.
      </ContainerLg>
    </Copyright>
  </>
)

export default FooterV2
